// extracted by mini-css-extract-plugin
var _1 = "src-components-visual-SimpleBlocks-module__block";
var _2 = "src-components-visual-SimpleBlocks-module__block_size_full";
var _3 = "src-components-visual-SimpleBlocks-module__block_span_all_columns";
var _4 = "src-components-visual-SimpleBlocks-module__block_span_all_rows";
var _5 = "src-components-visual-SimpleBlocks-module__content_align_center";
var _6 = "src-components-visual-SimpleBlocks-module__content_align_left";
var _7 = "src-components-visual-SimpleBlocks-module__content_align_right";
var _8 = "src-components-visual-SimpleBlocks-module__grid";
var _9 = "src-components-visual-SimpleBlocks-module__grid_type_properties";
var _a = "src-components-visual-SimpleBlocks-module__row";
var _b = "src-components-visual-SimpleBlocks-module__variant_empty";
var _c = "src-components-visual-SimpleBlocks-module__variant_left";
var _d = "src-components-visual-SimpleBlocks-module__variant_nested";
var _e = "src-components-visual-SimpleBlocks-module__variant_right";
export { _1 as "block", _2 as "block_size_full", _3 as "block_span_all_columns", _4 as "block_span_all_rows", _5 as "content_align_center", _6 as "content_align_left", _7 as "content_align_right", _8 as "grid", _9 as "grid_type_properties", _a as "row", _b as "variant_empty", _c as "variant_left", _d as "variant_nested", _e as "variant_right" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"block\":\"src-components-visual-SimpleBlocks-module__block\",\"block_size_full\":\"src-components-visual-SimpleBlocks-module__block_size_full\",\"block_span_all_columns\":\"src-components-visual-SimpleBlocks-module__block_span_all_columns\",\"block_span_all_rows\":\"src-components-visual-SimpleBlocks-module__block_span_all_rows\",\"content_align_center\":\"src-components-visual-SimpleBlocks-module__content_align_center\",\"content_align_left\":\"src-components-visual-SimpleBlocks-module__content_align_left\",\"content_align_right\":\"src-components-visual-SimpleBlocks-module__content_align_right\",\"grid\":\"src-components-visual-SimpleBlocks-module__grid\",\"grid_type_properties\":\"src-components-visual-SimpleBlocks-module__grid_type_properties\",\"row\":\"src-components-visual-SimpleBlocks-module__row\",\"variant_empty\":\"src-components-visual-SimpleBlocks-module__variant_empty\",\"variant_left\":\"src-components-visual-SimpleBlocks-module__variant_left\",\"variant_nested\":\"src-components-visual-SimpleBlocks-module__variant_nested\",\"variant_right\":\"src-components-visual-SimpleBlocks-module__variant_right\"}";
        // 1789978088652
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  